import axios from 'axios'
export default {
    namespaced: true,
    state: {
		endpoint: '/catalog/vehicle/price/type',
		params: {},
        item: {},
        items: [],
    },
}